import {
  REQUEST_MERCHANT,
  REQUEST_MERCHANT_LIST,
  REQUEST_MERCHANT_CATEGORY_LIST
} from './mutation-types'

export default {
  [REQUEST_MERCHANT_LIST](state, receivedData) {
    state.merchantList = receivedData.content;
    state.merchantListCount = receivedData.totalElements;
  },
  [REQUEST_MERCHANT](state, receivedData) {
    state.merchant = receivedData
  },
  [REQUEST_MERCHANT_CATEGORY_LIST](state, receivedData) {
    state.merchantCategoryListForCreate = receivedData
  },
}